module.exports = __webpack_public_path__ + "img/checklist-button-body2.744d1421.png";